import React from 'react';

import { useDispatch } from 'react-redux';

import Button from 'components/Button';
import { ENUM_TYPE_DOWNLOAD } from 'constants/enum';
import { TEXT_DOWNLOAD, TEXT_SURVEY_LIST } from 'constants/string/texts';
import { setOpenDownload, setOpenCreateOptions } from 'store/actions/survey';

const SurveyListHeader = ({ options }) => {
  const dispatch = useDispatch();
  const handleItemOverview = () => {
    const from = (options.page - 1) * options.page_size + 1;
    const to = from + options.page_size - 1;
    const total = options.total;

    return `${from} - ${to > total ? total : to} / ${total} ${TEXT_SURVEY_LIST.PART}`;
  };

  const handleOpenDownload = (typeDownload) => {
    dispatch(
      setOpenDownload({
        isOpen: true,
        type: typeDownload,
      })
    );
  };

  const handleOpenCreateOptions = () => {
    dispatch(
      setOpenCreateOptions({
        isOpen: true,
      })
    );
  };

  return (
    <div className="flex items-end justify-between gap-2 mt-2">
      <p className="text-sm opacity-85 text-gray-336">{handleItemOverview()}</p>
      <div className="flex space-x-4">
        <Button
          onClick={() => handleOpenDownload(ENUM_TYPE_DOWNLOAD.CSV)}
          color="outline"
          text={TEXT_DOWNLOAD.CSV_DOWNLOAD}
          className="w-55.75 h-9.5 text-sm !px-3.75 !py-1"
          icon={<img src={require('assets/resources/FileSave.svg').default} alt="plus icon" width={14} height={14} />}
        />
        <Button
          onClick={() => handleOpenDownload(ENUM_TYPE_DOWNLOAD.EXCEL)}
          color="outline"
          text={TEXT_DOWNLOAD.EXCEL_DOWNLOAD}
          className="w-57.25 h-9.5 text-sm !px-3.75 !py-1"
          icon={<img src={require('assets/resources/FileSave.svg').default} alt="plus icon" width={14} height={14} />}
        />
        <Button
          onClick={() => handleOpenCreateOptions()}
          color="primary"
          text={TEXT_SURVEY_LIST.CREATE_SURVEY}
          className="w-40 h-9.5"
          icon={<img src={require('assets/resources/Plus.svg').default} alt="plus icon" width={18} height={18} />}
        />
      </div>
    </div>
  );
};

export default React.memo(SurveyListHeader);
